import { Form } from "@/forms";
import { Table } from "@/tables";
import { ref, type Ref } from "vue";
import { Badge } from "../components/badges";
import { Button } from "../components/buttons";
import { Main } from "../components/main";
import { Misc } from "../components/misc";

export { PV, useToast, VR } from "./widgets.common";

export const My = {
    Badge: Badge,
    Button: Button,
    Form: Form,
    Main: Main,
    Misc: Misc,
    Table: Table,
};

export function createButton(fn: (isLoading: Ref<boolean>) => Promise<void>) {
    const isLoading = ref(false);

    return {
        isLoading: isLoading,
        onClick: async () => await fn(isLoading),
    };
}
